import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { prepareItem } from 'lib/checkout/userCartPrepare'
import { mapMultiCartAddItemResponse } from './multiCartMappers'
import { arrayToObject } from 'lib/array/arrayUtils'
import { isInstantBookingLEHotelItem, isBedbankItem } from 'lib/checkout/checkoutUtils'
import type { MachineContext } from 'typings/app/machineContext'

type AddItemsRequest = paths['/api/carts/multi-carts/{multiCartId}/items']['post']['parameters']['body']['payload']
type AddItemsResponse = paths['/api/carts/multi-carts/{multiCartId}/items']['post']['responses']['201']['content']['application/json']

export async function addItemsToMultiCart(cartId: string, items: Array<App.Checkout.AnyItem>, requestConnectedRooms: boolean = false, skipNotification: boolean): Promise<{ cartItems: MachineContext.CartItems, skipNotification: boolean }> {
  const preparedItems = items.map(item => {
    const preparedItem = prepareItem(item)
    if (requestConnectedRooms && (isInstantBookingLEHotelItem(item) || isBedbankItem(item))) {
      return {
        ...preparedItem,
        requestConnectedRooms: true
      }
    }
    return preparedItem
  })

  // TODO: remove this and change the villas type check
  const payload = { items: preparedItems } as AddItemsRequest
  const multiCartItems = await request.post<AddItemsResponse, AddItemsRequest>(`/api/carts/multi-carts/${cartId}/items`, payload, { credentials: 'include' }).then(mapMultiCartAddItemResponse)
  return { cartItems: { [cartId]: arrayToObject(multiCartItems, item => item.id) }, skipNotification }
}
